import React from 'react';
import Property from '../assets/images/Icon-dwelling-copy.svg';

export default () => {
  return <img src={Property} alt="" />;
};
